module.exports = __webpack_public_path__ + "static/img/2.20fc889.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/2.gif
// module id = NusM
// module chunks = 1